import { get, post } from '../utils/request'

// 创建并直接导出对象
export const kfApiService = {
  //处理用户查询
  async docsearch(params) {
    const response = await post('?s=/app.ApiOpenKf/docsearch', params);
    return response;
  },
  //获取js-sdk签名参数
  async getJsSdkSign(params) {
    const response = await post('?s=/app.ApiOpenKf/getJsSdkSign', params);
    return response;
  },
};
